<template>
  <CommonExpansionPanel :currentPanel="0">
    <template v-slot:title-panel> Buscar </template>
    <v-expansion-panel-content>
      <filters-polizas
        @searchUpdated="getEmisionesFilter"
        :currentFilters="filtros"
        :loading="loading"
      ></filters-polizas>
      <hr />
      <table-polizas
        :loading="loading"
        :emisiones="emisiones"
        :totalItems="totalItems"
        :page="page"
        :itemsPerPage="itemsPerPage"
        @pageChanged="onPageChanged"
        @itemsPerPageChanged="onItemsPerPageChanged"
      />    
    </v-expansion-panel-content>
  </CommonExpansionPanel>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import FiltersPolizas from "./FiltersPolizas.vue";
import TablePolizas from "./TablePolizas.vue";
import { mainAxios } from "@/mainAxios.js";
import { getEmisionesByFiltros } from "../../../../../services/emision/emision.service";

export default {
  components: {
    CommonExpansionPanel,
    FiltersPolizas,
    TablePolizas,
  },

  data() {
    return {
      switch_data: 1,
      emisiones: [],
      filtros: {},
      loading: false,
      page: 1,
      totalItems: 0,
      itemsPerPage: 10,
      emisionesStatus: [],
    };
  },
  props: {
    contactData: Object,
    correosDataFormat: Object,
    routesContactData: Object,
  },
  methods: {

    async getEmisionesFilter(filtros = this.filtros) {
      this.loading = true;
      this.filtros = filtros; // Guardamos filtros actuales para usar en cambios de página
      try {
        const offset = (this.page - 1) * this.itemsPerPage;
        const data = await getEmisionesByFiltros(filtros, this.itemsPerPage, offset);
        if (data && data.data.length) {
          this.emisiones = data.data.map((emision) => {
            const result = {
              ...emision,
              ...(emision.requestJson && {
                ...JSON.parse(emision.requestJson),
              }),
                  status:  this.emisionesStatus.find((e) => e.status == emision.status)?.etiqueta_api
            };
            result.inicio = this.$timezone.formatServerTimezone(result.inicio, "DD/MM/YYYY");
            result.fin = this.$timezone.formatServerTimezone(result.fin, "DD/MM/YYYY");
            return result;
          });
          this.totalItems = data.total; // <- backend debe mandar total
        } else {
          this.emisiones = [];
          this.totalItems = 0;
        }
      } finally {
        this.loading = false;
      }
    },


    getTodasLasSolicitudes() {
      const requestConfig = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get(`/v1/solicitud/info/status/1`, requestConfig)
        .then(({ data }) => {
          this.todasLasSolicitudes = data;
        });
    },
    onPageChanged(newPage) {
      this.page = newPage;
      this.getEmisionesFilter();
    },
    onItemsPerPageChanged(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.page = 1;
      this.getEmisionesFilter();
    },
        getEmisionesStatus(){
      const config = {
          headers: {
            Authorization: "Bearer " + localStorage.agenteAccessToken,
          },
        };
        mainAxios.get("/v1/emision/status", config)
        .then((response) => {
          this.emisionesStatus = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener lista de status:", error);
        });

    },
  },
  mounted() {
    if (( String(window.location.pathname).includes("/alianza/perfil/")) || (String(window.location.pathname).includes("/perfil/alianza"))) {
      this.getEmisiones({});
    }
    this.getEmisionesStatus()
  },
};
</script>
